import { TIME_RANGES } from '@worki/shared';
import type { Period } from '../components/PeriodPicker.js';

export function dashboardInvoicePeriod(params: URLSearchParams, now = new Date()): Period {
  const empty: Period = { range: 'all', month: '', years: [], from: '', to: '' };
  const year = Number(params.get('year')), month = Number(params.get('month'));
  if (Number.isInteger(year) && year >= 1900 && year <= 2200) return { ...empty, years: [String(year)], month: Number.isInteger(month) && month >= 1 && month <= 12 ? String(month) : '' };
  const range = params.get('range');
  if (range === 'today') {
    const day = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return { ...empty, from: day, to: day };
  }
  return range && TIME_RANGES.includes(range as typeof TIME_RANGES[number]) ? { ...empty, range: range as 'week' | 'month' | 'all' } : empty;
}
